import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { Heading } from 'components';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { SharedZoneBannersBlocks, SharedZoneBlocks } from 'store/SharedZone/blocks/selectors';
import { SharedZoneBannerBlockBannersContext } from 'store/SharedZone/blocks/contexts';

import BannersBlockImage from './components/BannersBlockImage';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

function BannersBlockLayout({ heading, headlineTagName, bannerIds, isMobile, className }) {
  return (
    <div className={cx('component', isMobile && 'mobile', className)}>
      {heading ?
        <Heading tagName={headlineTagName} level={2} className={cx('headline')}>
          {heading}
        </Heading>
      : null}
      <div className={cx('banners')}>
        {bannerIds.map((bannerId, index) => (
          <SharedZoneBannerBlockBannersContext.Provider value={bannerId} key={bannerId}>
            <BannersBlockImage {...{ index, isMobile }} />
          </SharedZoneBannerBlockBannersContext.Provider>
        ))}
      </div>
    </div>
  );
}

BannersBlockLayout.propTypes = {
  heading: PropTypes.string,
  headlineTagName: PropTypes.string,
  bannerIds: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};

const mapStateToProps = (state) => ({
  heading: SharedZoneBlocks.getHeadline(state),
  headlineTagName: SharedZoneBlocks.getHeadlineTagName(state),
  bannerIds: SharedZoneBannersBlocks.getBannerIdsList(state),
  isMobile: isScreenBelow640(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(BannersBlockLayout);
